// src/components/hooks/hooks-e-commerce/useAddressUpdate.js
import { useCallback } from 'react';
import axios from 'axios';

const PROVINCE_ABRUZZO = ['AQ', 'CH', 'PE', 'TE'];
const IVA_PERCENTUALE = 22;
const COSTO_PER_BOTTIGLIA = 3.40;

const isAbruzzo = (provincia) => {
    if (!provincia) return false;
    const upperProv = provincia.toString().toUpperCase();
    return PROVINCE_ABRUZZO.includes(upperProv);
};

export const useAddressUpdate = () => {
    
    const updateShippingAddress = useCallback(async (orderId, newAddress, currentOrder, isAddressModified = false) => {
    console.log('📦 Aggiornamento indirizzo spedizione:', { orderId, newAddress, isAddressModified });

        // ✅ CALCOLA COSTO BASE DAL NUMERO DI BOTTIGLIE
        const numeroBottiglie = currentOrder.numero_bottiglie || 0;
        const baseShippingCost = numeroBottiglie * COSTO_PER_BOTTIGLIA;
        
        console.log('🍾 Numero bottiglie:', numeroBottiglie);
        console.log('💰 Costo base spedizione:', baseShippingCost);
        
        // Determina se il nuovo indirizzo è in Abruzzo
        const isNewAbruzzo = isAbruzzo(newAddress.provincia);
        
        // Calcola nuovo costo spedizione e sconto
        let newShippingCost = baseShippingCost;
        let scontoSpedizione = 0;
        let scontoTipo = null;
        
        if (isNewAbruzzo) {
            scontoSpedizione = baseShippingCost * 0.5;
            newShippingCost = baseShippingCost - scontoSpedizione;
            scontoTipo = 'abruzzo_50';
            console.log('🎉 Sconto Abruzzo applicato: -€', scontoSpedizione);
        } else {
            console.log('📍 Nessuno sconto (provincia non Abruzzo)');
        }

        // 6. Ricalcola totali (IVA)
        const subtotale = parseFloat(currentOrder.subtotale) || 0;
        const speseImballaggio = parseFloat(currentOrder.spese_imballaggio) || 0;
        
        const imponibileProdotti = subtotale / (1 + IVA_PERCENTUALE / 100);
        const imponibileSpedizione = newShippingCost / (1 + IVA_PERCENTUALE / 100);
        const imponibileImballaggio = speseImballaggio / (1 + IVA_PERCENTUALE / 100);
        
        const ivaTotale = (imponibileProdotti + imponibileSpedizione + imponibileImballaggio) * (IVA_PERCENTUALE / 100);
        const importoTotale = imponibileProdotti + imponibileSpedizione + imponibileImballaggio + ivaTotale;

        console.log('💰 Nuovo costo spedizione:', newShippingCost);
        console.log('💰 Nuovo totale ordine:', importoTotale);
        
        // 7. Aggiorna DB
        const response = await axios.put(`/api/orders/${orderId}/address`, {
            indirizzo_spedizione: newAddress,
            costo_spedizione: newShippingCost,
            sconto_spedizione: scontoSpedizione,
            sconto_tipo: scontoTipo,
            importo_totale: importoTotale,
            importo_iva: ivaTotale
        });
        
        // ✅ CORRETTO: Axios usa response.status, non response.ok
        if (response.status !== 200) {
            throw new Error(`Errore aggiornamento indirizzo: ${response.statusText}`);
        }
        
        // ✅ CORRETTO: Axios parsa già il JSON, usa response.data
        const result = response.data;
        console.log('✅ Database aggiornato:', result);
        
        return result;
        
    }, []);
    
    const updateBillingAddress = useCallback(async (orderId, newAddress) => {
        console.log('📄 Aggiornamento indirizzo fatturazione:', { orderId, newAddress });
        
        const response = await axios.put(`/api/orders/${orderId}/address`, {
            indirizzo_fatturazione: newAddress
        });
        
        // ✅ CORRETTO
        if (response.status !== 200) {
            throw new Error('Errore aggiornamento indirizzo fatturazione');
        }
        
        // ✅ CORRETTO
        return response.data;
        
    }, []);
    
    return { updateShippingAddress, updateBillingAddress };
};